import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPlayFrame12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconPlayFrame12"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M10.5 2h-9a.5.5 0 0 0-.5.5V3h10v-.5a.5.5 0 0 0-.5-.5M1 9.786V4h10v5.786a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5M1.5 1A1.5 1.5 0 0 0 0 2.5v7.286a1.5 1.5 0 0 0 1.5 1.5h9a1.5 1.5 0 0 0 1.5-1.5V2.5A1.5 1.5 0 0 0 10.5 1zm4 7.362V5.763l1.89 1.33zm.575-3.417a1 1 0 0 0-1.575.818v2.599a1 1 0 0 0 1.557.83l1.89-1.27a1 1 0 0 0 .018-1.647z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPlayFrame12);
